export default "__VITE_ASSET__BDpwWcWm__"